import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { useDictionary } from '@/lib/i18n'

const StatsStrip: FC = (): ReactNode => {
    const t = useDictionary()

    return (
        <section id='key-figures' aria-label={t.story.glance.title} className='border-y border-border bg-black/30'>
            <dl className='mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4'>
                {t.stats.map((stat, index) => (
                    <div
                        key={stat.label}
                        className={cn(
                            'flex flex-col gap-2 px-5 py-8 sm:px-8 sm:py-10',
                            index % 2 === 1 && 'border-l',
                            index >= 2 && 'border-t lg:border-t-0',
                            index === 2 && 'lg:border-l'
                        )}
                    >
                        <dt className='order-2 max-w-[16rem] text-sm leading-snug text-muted-foreground'>
                            {stat.label}
                        </dt>

                        <dd className='order-1 font-heading text-5xl font-semibold leading-none tracking-tight text-foreground sm:text-6xl'>
                            {stat.value}

                            {stat.unit && (
                                <span className='ml-1 text-2xl text-race-bright sm:text-3xl'>
                                    {stat.unit}
                                </span>
                            )}
                        </dd>
                    </div>
                ))}
            </dl>
        </section>
    )
}

export default StatsStrip
